import { createContext } from 'react';

export enum Service {
  BUY = 'buying',
  SELL = 'selling',
  BUY_AND_SELL = 'buying-and-selling',
  REMORTGAGE = 'remortgaging',
}

interface QuickQuoteContextProps {
  service: Service | string | null;
  setService: (service: Service) => void;
  quoteStep: number;
  setQuoteStep: (step: number) => void;
}

export const QuickQuoteContext = createContext<QuickQuoteContextProps>({
  service: null,
  setService: () => {},
  quoteStep: 0,
  setQuoteStep: () => {},
});
